import template from './listing_view_asset_modal.html';

angular.module('bb.listing_view').directive('listingAssetModal', () => {
  return {
    restrict: 'E',
    scope: {
      assets: '=',
      index: '<',
    },
    controller: ListingAssetModal,
    bindToController: true,
    controllerAs: 'vm',
    template,
  };
});

ListingAssetModal.$inject = ['$timeout', 'ModalService', '$scope'];
function ListingAssetModal($timeout, ModalService, $scope) {
  const vm = this;

  vm.modalID = `listing-asset-modal`;
  vm.thumbnailID = `listing-asset-modal-thumbnails`;
  vm.childLeft = `listing-asset-modal-left-child`;
  vm.childRight = `listing-asset-modal-right-child`;

  vm.setIndex = function (idx, init) {
    const { index } = vm;
    vm.index = Math.min(Math.max(idx, 0), vm.assets.length - 1);
    vm.calculateOffset(index, vm.index);
    const copy = angular.copy(vm.assets[vm.index]);
    copy.display = true;
    vm.selectedAsset = copy;
  };

  vm.$onInit = function () {
    const tmp = vm.index;
    vm.index = 0;
    vm.setIndex(tmp);
  };

  vm.calculateOffset = function (oldIndex, newIndex) {
    $timeout(() => {
      const width = $(`#${vm.modalID}`).width();
      const offset = `${Math.ceil(width / 2) - Math.ceil(width * 0.075)}px`;
      $(`#${vm.childLeft}`).css('paddingLeft', offset);
      $(`#${vm.childRight}`).css('paddingRight', offset);
      const imageWidth = Math.ceil(width * 0.15);
      const indexDiff = newIndex - oldIndex;

      $(`#${vm.thumbnailID}`).animate(
        {
          scrollLeft: `${indexDiff < 0 ? '-' : '+'}=${
            imageWidth * Math.abs(indexDiff)
          }`,
        },
        300,
        'easeOutQuart',
      );
    });
  };

  vm.isMobileView = () => $scope.$root.isMobileView;

  vm.close = function () {
    ModalService.closeAssetModal();
  };
}
